import React from 'react';

export const recordsPermissionNotice = (
  <p>
    We’ll ask you to give us permission to request your private medical records
    later in the application. If you have medical records at the VA, we’ll get
    those for you.
  </p>
);
